{
  "list": {
    "title": "过滤器",
    "create": "创建过滤器",
    "import": "导入过滤器",
    "loadError": "加载过滤器时发生错误。",
    "statusAll": "全部",
    "statusEnabled": "已启用",
    "statusDisabled": "已禁用",
    "noStatusFilters": "没有{{status}}过滤器",
    "noFilters": "这里还没有过滤器..",
    "addNew": "新增",
    "copied": "过滤器已复制到剪贴板！",
    "copyFailed": "复制 JSON 到剪贴板失败。",
    "fetchFailed": "获取过滤器数据失败。",
    "deleted": "过滤器 {{name}} 已删除",
    "duplicated": "过滤器 {{name}} 已复制",
    "updated": "{{name}} 更新成功",
    "removeTitle": "移除过滤器：{{name}}",
    "removeText": "确定要移除此过滤器吗？此操作无法撤销。",
    "edit": "编辑",
    "exportJson": "导出 JSON",
    "exportJsonDiscord": "导出 JSON 到 Discord",
    "toggle": "切换",
    "duplicate": "复制",
    "delete": "删除",
    "toggleSuccess": "{{name}} 已{{state}}成功",
    "enabledState": "启用",
    "disabledState": "禁用",
    "autoUpdatedTitle": "此过滤器会被列表自动更新",
    "priority": "优先级",
    "actions": "动作",
    "noActionsDefined": "还没有配置动作。请先设置动作，否则无法执行抓取。",
    "noActionsEnabled": "你至少需要启用一个动作，否则不会有任何抓取发生。",
    "downloads": "下载",
    "per": "每",
    "usesDisabledIndexers": "使用了已禁用的索引器：{{names}}",
    "noIndexer": "无索引器",
    "sort": {
      "label": "排序",
      "default": "最新",
      "nameAsc": "名称 A-Z",
      "nameDesc": "名称 Z-A",
      "priorityDesc": "优先级 高到低",
      "priorityAsc": "优先级 低到高",
      "createdDesc": "最近创建优先",
      "createdAsc": "最早创建优先",
      "updatedDesc": "最近更新优先",
      "updatedAsc": "最早更新优先"
    },
    "indexerFilter": {
      "label": "索引器",
      "all": "全部索引器"
    }
  },
  "details": {
    "tabs": {
      "general": "常规",
      "moviesTv": "电影和剧集",
      "music": "音乐",
      "advanced": "高级",
      "external": "外部",
      "actions": "动作",
      "notifications": "通知",
      "new": "新"
    },
    "removeTitle": "移除过滤器：{{name}}",
    "removeText": "确定要移除此过滤器吗？此操作无法撤销。",
    "delete": "删除过滤器",
    "reset": "重置表单内容",
    "resetSuccess": "已重置所有过滤器字段。",
    "save": "保存",
    "validationError": "校验错误",
    "validationErrors": "校验错误",
    "mustSelectClient": "必须选择客户端"
  },
  "importer": {
    "title": "导入过滤器（JSON 或 autodl-irssi 格式）",
    "import": "导入",
    "cancel": "取消",
    "jsonImported": "过滤器“{{name}}”导入成功！",
    "jsonImportFailed": "导入 JSON 数据失败。详细信息已记录到控制台。",
    "invalidFormat": "无法导入给定过滤器，它既不是 JSON 格式，也不是 autodl-irssi 格式。",
    "autodlImportFailed": "导入 autodl-irssi 过滤器“{{name}}”失败。详细信息已记录到控制台。",
    "autodlImportedOne": "过滤器“{{name}}”导入成功！",
    "autodlImportedMany": "全部 {{count}} 个过滤器导入成功！",
    "autodlImportedPartial": "成功导入 {{success}}/{{total}} 个过滤器。详情请查看控制台。",
    "placeholder": "在这里粘贴你的过滤器数据（autobrr JSON 格式或完整 autodl-irssi 配置）",
    "warnings": "导入警告"
  },
  "general": {
    "filterName": "过滤器名称",
    "filterNamePlaceholder": "例如：Filter 1",
    "announceTypes": "公告类型",
    "announceTypesTooltip": "新增！匹配包含任一所选公告类型的发布。",
    "indexers": "索引器",
    "rulesTitle": "规则",
    "rulesSubtitle": "指定种子如何被处理或筛选。",
    "minSize": "最小大小",
    "maxSize": "最大大小",
    "sizePlaceholder": "例如：100MiB、80GB",
    "sizeTooltip": "支持 MB、MiB、GB 等单位。",
    "delay": "延迟",
    "delayPlaceholder": "动作延迟执行的秒数",
    "delayTooltip": "在执行动作前等待的秒数。",
    "priority": "优先级",
    "priorityPlaceholder": "数字越高优先级越高",
    "priorityTooltip": "过滤器会按优先级顺序检查，数字越高优先级越高。",
    "maxDownloads": "最大下载数",
    "maxDownloadsPlaceholder": "接受任意数字（0 表示无限）",
    "maxDownloadsTooltip": "对应时间单位内允许的最大下载数。",
    "maxDownloadsPer": "最大下载数 /",
    "selectUnit": "选择单位",
    "maxDownloadsPerTooltip": "统计每个过滤器最大下载数所使用的时间单位。",
    "skipDuplicatesProfile": "跳过重复项配置",
    "selectProfile": "选择配置",
    "skipDuplicatesProfileTooltip": "选择用于跳过重复项的配置。",
    "enabled": "启用",
    "enabledDescription": "启用或禁用此过滤器。"
  },
  "actionsSection": {
    "title": "动作",
    "subtitle": "添加到下载客户端或执行自定义命令。",
    "addNew": "新增",
    "empty": "还没有动作！",
    "deleted": "动作 {{name}} 已删除",
    "removeTitle": "移除过滤器动作",
    "removeText": "确定要移除此动作吗？此操作无法撤销。",
    "actionTitle": "动作",
    "actionSubtitle": "定义该动作使用的下载客户端和名称",
    "actionType": "动作类型",
    "selectType": "选择类型",
    "actionTypeTooltip": "为此动作选择动作类型。",
    "name": "名称",
    "removeAction": "移除动作",
    "close": "关闭"
  },
  "notificationsSection": {
    "title": "过滤器通知",
    "subtitle": "配置该过滤器要发送哪些通知。这些设置会覆盖全局通知设置。",
    "addNotification": "添加通知",
    "empty": "当前没有为此过滤器配置专属通知，将使用全局通知。",
    "selectNotification": "选择通知",
    "muted": "静音",
    "eventsCount_one": "{{count}} 个事件",
    "eventsCount_other": "{{count}} 个事件",
    "removeTitle": "移除通知",
    "removeText": "确定要移除此通知吗？此操作无法撤销。",
    "notificationTitle": "通知",
    "notificationSubtitle": "选择要使用的通知服务和触发事件",
    "notificationService": "通知服务",
    "selectNotificationService": "选择一个通知",
    "notificationServiceTooltip": "选择该过滤器要使用的通知服务。",
    "notificationSettings": "通知设置",
    "muteFilter": "静音过滤器",
    "muteFilterDesc": "禁用该过滤器的所有通知。静音后，匹配到的发布不会发送任何通知。",
    "mutedInfo": "过滤器已静音，将覆盖所有全局通知设置",
    "triggerEvents": "触发事件",
    "pushApproved": "推送成功",
    "pushRejected": "推送被拒绝",
    "pushError": "推送错误",
    "pushApprovedDesc": "当发布成功发送到客户端时发送通知",
    "pushRejectedDesc": "当发布被拒绝时发送通知",
    "pushErrorDesc": "当处理过程中发生错误时发送通知",
    "removeNotification": "移除通知",
    "close": "关闭"
  },
  "advanced": {
    "common": {
      "useRegex": "使用正则",
      "regexTooltip1": "该字段支持完整正则表达式（Golang 风格）。",
      "regexTooltip2": "如果使用的不只是 * 和 ?，请记得勾选“使用正则”。",
      "regexTooltip3": "模式：(?i) 不区分大小写"
    },
    "releases": {
      "title": "发布名称",
      "subtitle": "仅匹配特定发布名称，或忽略其他发布名称。",
      "match": "匹配发布",
      "matchPlaceholder": "例如：*some?movie*,*some?show*s01*",
      "except": "排除发布",
      "exceptPlaceholder": "例如：*bad?movie*,*bad?show*s03*",
      "alert": "请先想一想：",
      "matchWarning": "你是否真的需要使用“匹配发布”，而不是其他标签页里的规则？",
      "exceptWarning": "你是否真的需要使用“排除发布”，而不是其他标签页里的规则？"
    },
    "groups": {
      "title": "小组",
      "subtitle": "仅匹配特定小组，或忽略其他小组。",
      "match": "匹配发布小组",
      "matchPlaceholder": "例如：group1,group2",
      "matchTooltip": "用逗号分隔要匹配的发布小组列表。",
      "except": "排除发布小组",
      "exceptPlaceholder": "例如：badgroup1,badgroup2",
      "exceptTooltip": "用逗号分隔要忽略的发布小组列表（优先级高于匹配发布小组）。"
    },
    "categories": {
      "title": "分类",
      "subtitle": "匹配或排除分类（如果公告里包含）",
      "match": "匹配分类",
      "matchPlaceholder": "例如：*category*,category1",
      "matchTooltip": "用逗号分隔要匹配的分类列表。",
      "except": "排除分类",
      "exceptPlaceholder": "例如：*category*",
      "exceptTooltip": "用逗号分隔要忽略的分类列表（优先级高于匹配分类）。"
    },
    "tags": {
      "title": "标签",
      "subtitle": "匹配或排除标签（如果公告里包含）",
      "match": "匹配标签",
      "matchPlaceholder": "例如：tag1,tag2",
      "matchTooltip": "用逗号分隔要匹配的标签列表。",
      "matchLogic": "匹配逻辑",
      "matchLogicDefault": "任意",
      "matchLogicTooltip": "用于匹配过滤器标签的逻辑。",
      "except": "排除标签",
      "exceptPlaceholder": "例如：tag1,tag2",
      "exceptTooltip": "用逗号分隔要忽略的标签列表（优先级高于匹配标签）。",
      "exceptLogic": "排除逻辑",
      "exceptLogicDefault": "任意",
      "exceptLogicTooltip": "用于匹配排除标签的逻辑。"
    },
    "uploaders": {
      "title": "发布者",
      "subtitle": "匹配或忽略发布者（如果公告里包含）",
      "match": "匹配发布者",
      "matchPlaceholder": "例如：uploader1,uploader2",
      "matchTooltip": "用逗号分隔要匹配的发布者列表。",
      "except": "排除发布者",
      "exceptPlaceholder": "例如：anonymous1,anonymous2",
      "exceptTooltip": "用逗号分隔要忽略的发布者列表（优先级高于匹配发布者）。"
    },
    "language": {
      "title": "语言",
      "subtitle": "匹配或忽略语言（如果公告里包含）",
      "match": "匹配语言",
      "except": "排除语言"
    },
    "origins": {
      "title": "来源",
      "subtitle": "匹配 Internal、Scene、P2P 等来源（如果公告里包含）",
      "match": "匹配来源",
      "except": "排除来源"
    },
    "freeleech": {
      "title": "Freeleech",
      "subtitle": "根据 Freeleech 状态进行匹配（如果公告里包含）",
      "percent": "Freeleech 百分比",
      "percentPlaceholder": "例如：50,75-100",
      "percentTooltip1": "根据索引器不同，Freeleech 可能以 true/false 或百分比形式公告。二者选其一即可。",
      "percentTooltip2": "如果开启下面的 Freeleech 开关，它会覆盖此字段。",
      "percentTooltip3": "更多说明请参考文档：",
      "toggle": "Freeleech",
      "toggleDescription": "不能与 Freeleech 百分比同时使用。开启后会覆盖 Freeleech 百分比。",
      "toggleTooltip1": "根据索引器不同，Freeleech 可能以 true/false 或百分比形式公告。二者选其一即可。",
      "toggleTooltip2": "如果此字段被开启为 true，会覆盖 Freeleech 百分比。",
      "toggleTooltip3": "不同来源的使用方式请参考文档："
    },
    "feedSpecific": {
      "title": "RSS/Torznab/Newznab 专属",
      "subtitle": "这些选项仅适用于 RSS、Torznab 和 Newznab 等订阅源",
      "matchDescription": "匹配描述",
      "matchDescriptionPlaceholder": "例如：*some?movie*,*some?show*s01*",
      "exceptDescription": "排除描述",
      "exceptDescriptionPlaceholder": "例如：*bad?movie*,*bad?show*s03*",
      "minSeeders": "最少做种数",
      "maxSeeders": "最多做种数",
      "minLeechers": "最少下载数",
      "maxLeechers": "最多下载数",
      "countPlaceholder": "接受任意数字（0 表示无限）",
      "seedersTooltip": "按相应单位指定的{{type}}数量。仅适用于 Torznab。"
    },
    "rawReleaseTags": {
      "title": "原始 Release Tags",
      "subtitlePrefix": "仅限高级用户",
      "subtitleSuffix": "这里是公告中的原始 releaseTags 字符串。",
      "warning": "这些字段可能并不是你以为的含义。仅适合非常熟悉解析方式的高级用户。",
      "match": "匹配 release tags",
      "except": "排除 release tags",
      "placeholder": "例如：*mkv*,*foreign*"
    }
  },
  "moviesTv": {
    "title": "电影 / 剧集",
    "placeholder": "例如：Movie,Show 1,Show?2",
    "wildcardTooltip": "你可以使用通配符 *，或者用 ? 替代单个字符进行基础匹配。",
    "years": "年份",
    "yearsPlaceholder": "例如：2018,2019-2021",
    "yearsTooltip": "该字段支持年份范围和逗号分隔的单个年份。",
    "seasonEpisode": {
      "title": "季度、集数与日期",
      "subtitle": "设置季度、集数、年份、月份和日期的匹配条件。",
      "seasons": "季度",
      "seasonsPlaceholder": "例如：1,3,2-6",
      "seasonsTooltip": "关于如何只抓取整季包，请查看文档：",
      "episodes": "集数",
      "episodesPlaceholder": "例如：2,4,10-20",
      "episodesTooltip": "关于如何只抓取单集，请查看文档：",
      "dailyShows": "日播节目",
      "months": "月份",
      "monthsPlaceholder": "例如：4,2-9",
      "monthsTooltip": "该字段支持月份范围和逗号分隔的单个月份。",
      "days": "日期",
      "daysPlaceholder": "例如：1,15-30",
      "daysTooltip": "该字段支持日期范围和逗号分隔的单个日期。",
      "smartEpisode": "智能集数",
      "smartEpisodeDescription": "不要匹配早于上一次已匹配集数的内容。"
    },
    "quality": {
      "title": "画质",
      "subtitle": "设置分辨率、来源、编码及相关匹配条件。",
      "resolutions": "分辨率",
      "resolutionsTooltip": "会匹配包含任一所选分辨率的发布。",
      "sources": "来源",
      "sourcesTooltip": "会匹配包含任一所选来源的发布。",
      "codecs": "编码",
      "codecsTooltip": "会匹配包含任一所选编码的发布。",
      "containers": "封装",
      "containersTooltip": "会匹配包含任一所选封装格式的发布。",
      "matchHdr": "匹配 HDR",
      "matchHdrTooltip": "会匹配包含任一所选 HDR 标识的发布。",
      "exceptHdr": "排除 HDR",
      "exceptHdrTooltip": "不会匹配包含任一所选 HDR 标识的发布（优先级高于匹配 HDR）。",
      "matchOther": "匹配其他标识",
      "matchOtherTooltip": "会匹配包含任一所选附加标识的发布。",
      "exceptOther": "排除其他标识",
      "exceptOtherTooltip": "不会匹配包含任一所选附加标识的发布（优先级高于匹配其他标识）。"
    }
  },
  "music": {
    "artists": "艺术家",
    "artistsPlaceholder": "例如：Artist One",
    "albums": "专辑",
    "albumsPlaceholder": "例如：That Album",
    "wildcardTooltip": "你可以使用通配符 *，或者用 ? 替代单个字符进行基础匹配。",
    "matchRecordLabels": "匹配唱片公司",
    "matchRecordLabelsPlaceholder": "例如：Anjunabeats, Armada",
    "matchRecordLabelsTooltip": "用逗号分隔要匹配的唱片公司。仅 Orpheus 和 Redacted 支持。",
    "exceptRecordLabels": "排除唱片公司",
    "exceptRecordLabelsPlaceholder": "例如：Anjunadeep, Armind",
    "exceptRecordLabelsTooltip": "用逗号分隔要忽略的唱片公司（优先级高于匹配唱片公司）。仅 Orpheus 和 Redacted 支持。",
    "releaseDetails": {
      "title": "发布详情",
      "subtitle": "匹配类型（专辑、单曲、EP 等）和发布日期年份（如果公告中包含）",
      "musicType": "音乐类型",
      "musicTypeTooltip": "仅匹配包含任一所选类型的发布。",
      "years": "年份",
      "yearsPlaceholder": "例如：2018,2019-2021",
      "yearsTooltip": "该字段支持年份范围和逗号分隔的单个年份。"
    },
    "quality": {
      "title": "音质",
      "subtitle": "格式、来源、日志等。",
      "format": "格式",
      "formatTooltip": "仅匹配包含任一所选格式的发布。开启 Perfect FLAC 后会覆盖此项。",
      "quality": "质量",
      "qualityTooltip": "仅匹配包含任一所选质量的发布。开启 Perfect FLAC 后会覆盖此项。",
      "media": "媒介",
      "mediaTooltip": "仅匹配包含任一所选来源的发布。开启 Perfect FLAC 后会覆盖此项。",
      "cue": "Cue",
      "cueDescription": "必须包含 CUE 信息",
      "log": "Log",
      "logDescription": "必须包含 LOG 信息",
      "logScore": "Log 分数",
      "logScorePlaceholder": "例如：100",
      "logScoreTooltip": "Log 分数范围为 0 到 100。开启 Perfect FLAC 后会覆盖此项。",
      "or": "或",
      "perfectFlac": "Perfect FLAC",
      "perfectFlacDescription": "覆盖所有关于质量、来源、格式以及 cue/log/log score 的选项。",
      "perfectFlacTooltip": "覆盖所有关于质量、来源、格式以及 CUE/LOG/LOG score 的选项。",
      "perfectFlacHint": "在 90% 的场景里，你真正想要的通常就是这个，而不是上面的细项。"
    }
  },
  "external": {
    "title": "外部过滤器",
    "subtitle": "在过滤过程中运行外部脚本或 Webhook，并检查其返回状态。",
    "addNew": "新增",
    "empty": "还没有外部过滤器！",
    "removeTitle": "移除外部过滤器",
    "removeText": "确定要移除此外部过滤器吗？此操作无法撤销。",
    "sectionTitle": "外部过滤器",
    "sectionSubtitle": "定义过滤器类型及其名称",
    "type": "类型",
    "name": "名称",
    "onError": "出错时",
    "selectType": "选择类型",
    "typeTooltip": "选择此外部过滤器的类型。",
    "onErrorTooltip": "选择此外部过滤器发生错误时的处理方式。",
    "remove": "移除外部过滤器",
    "close": "关闭",
    "types": {
      "EXEC": "执行命令",
      "WEBHOOK": "Webhook"
    },
    "onErrorOptions": {
      "REJECT": "拒绝",
      "CONTINUE": "继续下一个"
    },
    "execute": {
      "title": "执行",
      "subtitle": "指定要作为预过滤器运行的可执行文件、参数和期望退出状态",
      "path": "可执行文件路径",
      "pathPlaceholder": "可执行文件绝对路径，例如 /bin/test",
      "pathTooltip": "对于自定义命令，你应填写要运行的二进制/程序完整路径，也可以带上你自己的静态变量：",
      "args": "执行参数",
      "argsPlaceholder": "参数，例如 --test \"{{ .TorrentName }}\"",
      "expectedExitStatus": "期望退出状态"
    },
    "request": {
      "title": "请求",
      "subtitle": "指定请求目标地址、请求头和期望返回状态",
      "endpoint": "端点",
      "endpointPlaceholder": "地址，例如 http://localhost/webhook",
      "endpointTooltip": "填写你的 API URL 或 IP。可附带参数并设置 API token 等。",
      "httpMethod": "HTTP 方法",
      "httpMethodDefault": "选择 HTTP 方法",
      "httpMethodTooltip": "选择此 Webhook 使用的 HTTP 方法，默认是 POST。",
      "headers": "HTTP 请求头",
      "headersPlaceholder": "HEADER=custom1,HEADER2=custom2",
      "expectedStatus": "期望 HTTP 状态码"
    },
    "retry": {
      "title": "重试",
      "subtitle": "请求失败时的重试行为",
      "retryStatus": "遇到这些 HTTP 状态码时重试",
      "retryStatusPlaceholder": "例如状态码 202, 204 时重试",
      "retryAttempts": "最大重试次数",
      "retryDelaySeconds": "重试延迟（秒）"
    },
    "payload": {
      "title": "负载",
      "subtitle": "指定你的 JSON 负载",
      "data": "数据（json）",
      "dataPlaceholder": "请求数据：{ \"key\": \"value\" }"
    }
  },
  "actionComponents": {
    "instance": {
      "title": "实例",
      "subtitle": "选择要处理此发布过滤器的具体实例。"
    },
    "common": {
      "category": "分类",
      "categoryPlaceholder": "例如：category",
      "categoryTooltip": "分类必须预先存在。",
      "savePath": "保存路径",
      "savePathPlaceholder": "例如：/full/path/to/download_folder",
      "numberNoLimit": "接受任意数字（0 表示不限速）",
      "limitsTitle": "限制",
      "limitsSubtitle": "配置速度、分享率和做种时间限制",
      "limitDownloadKib": "限制下载速度 (KiB/s)",
      "limitUploadKib": "限制上传速度 (KiB/s)",
      "limitDownloadKb": "限制下载速度 (KB/s)",
      "limitUploadKb": "限制上传速度 (KB/s)",
      "ratioLimit": "分享率限制",
      "seedTimeMinutes": "做种时间限制（分钟）",
      "addPaused": "添加为暂停",
      "addPausedDescription": "将种子以暂停状态添加",
      "skipHashCheck": "跳过哈希校验",
      "skipHashCheckDescription": "添加种子并跳过哈希校验",
      "announceTitle": "重汇报",
      "announceSubtitle": "设置重汇报次数、失败多少次后删除等行为。",
      "disableReannounce": "禁用重汇报",
      "disableReannounceDescription": "默认启用重汇报，如果不需要可以禁用",
      "reannounceInterval": "重汇报间隔，每 X 秒执行一次",
      "reannounceIntervalPlaceholder": "默认且推荐为 7",
      "deleteStalled": "删除卡住任务",
      "deleteStalledDescription": "尝试 Y 次后删除卡住的种子",
      "reannounceMaxAttempts": "执行 Y 次重汇报"
    },
    "test": {
      "alert": "提示",
      "text": "测试动作本身不会执行任何下载，只用于展示过滤器是否命中。测试时请打开日志页面观察结果。"
    },
    "exec": {
      "title": "Exec 参数",
      "subtitle": "指定过滤器命中后要执行的程序及其参数。请使用绝对路径。",
      "path": "可执行文件路径",
      "pathPlaceholder": "程序路径，例如 /bin/test",
      "arguments": "参数",
      "argumentsPlaceholder": "参数，例如 --test"
    },
    "watchFolder": {
      "title": "监视目录参数",
      "subtitle": "指定 autobrr 应将抓取到的文件保存到哪里。请使用绝对路径。",
      "directory": "监视目录",
      "directoryPlaceholder": "监视目录，例如 /home/user/rwatch"
    },
    "webhook": {
      "title": "Webhook 参数",
      "subtitle": "指定过滤器命中后要发送到目标端点的负载。",
      "endpoint": "端点",
      "endpointPlaceholder": "地址，例如 http://localhost/webhook",
      "endpointTooltip": "填写你的 API URL 或 IP。可附带参数并设置 API token 等。",
      "payload": "负载（json）",
      "payloadPlaceholder": "请求数据：{ \"key\": \"value\" }"
    },
    "arr": {
      "overrideClientName": "为 arr 覆盖下载客户端名称",
      "overrideClientNameTooltip": "覆盖 Clients 中设置的下载客户端名称。如果 arr 内配置了多个客户端，这会很有用。",
      "overrideClientId": "为 arr 覆盖下载客户端 ID（已弃用）",
      "overrideClientIdTooltip": "覆盖 Clients 中设置的下载客户端 ID。如果 arr 内配置了多个客户端，这会很有用。"
    },
    "qbittorrent": {
      "macrosTooltip": "此字段可使用宏从元数据中转换或追加值：",
      "tags": "标签",
      "tagsPlaceholder": "例如：tag1,tag2",
      "savePathPlaceholder": "例如：/full/path/to/save_folder",
      "savePathTooltip": "为此动作设置自定义保存路径。如果你在 qBittorrent 中配合分类使用自动种子管理，通常会由它自动处理。",
      "downloadPath": "下载路径",
      "downloadPathPlaceholder": "例如：/full/path/to/download_folder",
      "downloadPathTooltip": "为此动作设置自定义下载（未完成）路径。如果你在 qBittorrent 中配合分类使用自动种子管理，通常会由它自动处理。",
      "rulesTitle": "规则",
      "rulesSubtitle": "配置种子客户端规则",
      "ignoreRules": "忽略现有客户端规则",
      "ignoreRulesDescription": "选择是否忽略客户端设置中定义的规则。",
      "contentLayout": "内容布局",
      "contentLayoutDefault": "选择内容布局",
      "priority": "优先级",
      "priorityDefault": "禁用",
      "priorityTooltip": "如果当前关闭了 Torrent Queueing，将为你自动启用。请确认已在客户端中设置好你偏好的相关限制。",
      "firstLastPiece": "优先下载首尾分片",
      "firstLastPieceDescription": "添加种子并优先下载首尾分片"
    },
    "deluge": {
      "label": "标签",
      "labelPlaceholder": "例如：label1（必须先在 Deluge 中存在）",
      "skipHashCheckTooltip": "此选项仅在 Deluge v2 中生效。"
    },
    "transmission": {
      "label": "种子标签",
      "labelPlaceholder": "例如：label1,label2"
    },
    "rtorrent": {
      "label": "标签",
      "labelPlaceholder": "例如：label1,label2",
      "renameToPath": "不要把种子名称加到路径中",
      "renameDefault": "否"
    },
    "porla": {
      "preset": "预设",
      "presetPlaceholder": "例如：default",
      "presetTooltip": "这里填写在 Porla 中配置的区分大小写的预设名称。",
      "savePathPlaceholder": "例如：/full/path/to/torrent/data"
    }
  },
  "addForm": {
    "title": "创建过滤器",
    "subtitle": "新增一个过滤器。",
    "closePanel": "关闭面板",
    "name": "名称",
    "required": "必填",
    "cancel": "取消",
    "create": "创建",
    "added": "过滤器 {{name}} 已添加"
  }
}
